<template>
<img src="static/icons/download.png"/>
</template>

<script>
export default {
  name: 'logo',
  props: ['light', 'konami'],
};
</script>
